const { getAll } = require( "@/utilities/querySelector" );


const tooltippers = getAll( '[data-nuwoo-tooltip' );


tooltippers.forEach( initTooltip );

/**
 * @param {HTMLElement} element
 *
 * @return void
 */
function initTooltip( element ) {
    element.addEventListener( 'mouseenter', popUp );
    element.addEventListener( 'mouseleave', popDown );

    /** @type {HTMLElement|null} */
    let tooltip;

    /**
     * @param {MouseEvent} e
     *
     * @return void
     */
    function popUp( e ) {
        const content = element.getAttribute( 'data-nuwoo-tooltip' );
        const position = element.getBoundingClientRect();

        tooltip = document.createElement( 'div' );
        tooltip.classList.add( 'nuwoo-tooltip' );
        tooltip.textContent = content;
        tooltip.setAttribute( 'role', 'tooltip' );
        tooltip.style.setProperty( 'left', `${( ( position?.left + position?.right ) / 2 ).toString()}px` );
        tooltip.style.setProperty( 'top', `${( position?.bottom + 6 ).toString()}px` );

        document.body.appendChild( tooltip );
    }

    /**
     * @param {MouseEvent} e
     *
     * @return void
     */
    function popDown( e ) {
        tooltip?.remove();
    }

}
